/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Title_LeadInputs */

const en_landing_how_title_lead = /** @type {(inputs: Landing_How_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three taps`)
};

const pl_landing_how_title_lead = /** @type {(inputs: Landing_How_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trzy kliknięcia`)
};

/**
* | output |
* | --- |
* | "Three taps" |
*
* @param {Landing_How_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_how_title_lead = /** @type {((inputs?: Landing_How_Title_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Title_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_how_title_lead(inputs)
	return en_landing_how_title_lead(inputs)
});